import React from 'react';
import "./c86_accordions_with_tables.scss";
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { insertHtml } from "../../utils/dom";
import { isMobile, isMobileOnly, isTablet } from 'react-device-detect'

const AccordionsWithTables = (props) => {
    return <div id="accordionsWithTables" className="container-fluid">
        <div className="title">{props.data.title}</div>
        {props.data.subtitle && <div className="subtitle">{props.data.subtitle}</div>}
        <div className="accordion">
            {props.data.accordions_group && props.data.accordions_group.map((object, index) => (
                <Accordion key={index}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <div className="heading"><img src={`/${object.flag}.svg`} alt={object.flag} /> <span className="study-title">{object.study_title}</span></div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div className="container-fluid">
                            {object.plan_title && <div className="row plan-title">{object.plan_title}</div>}
                            {object.plan_details && <div className="row plan-details" {...insertHtml(object.plan_details)} />}
                            <div className="row tables-title">{object.tables_title}</div>
                            {object.tables && object.tables.map((table, index) => (
                                <div key={index} className="table container-fluid">
                                    <div className="table-heading row">
                                        <span className="rectangle"></span>
                                        {!isMobileOnly ? <span className="duration col-10">{table.duration}</span> : <span className="duration col-9">{table.duration}</span>}
                                        <span className="credits-label col-1">{table.credits_label}</span>
                                    </div>
                                    <hr />
                                    {table.rows && table.rows.map((row, index) => (
                                        <div key={index} className="table-body container-fluid">
                                            <div className="title-course row">{row.title}</div>
                                            <div className="description-row row">
                                                {isTablet ? <div className="description col-11">{row.description}</div> : (!isMobileOnly ? <div className="description col-10">{row.description}</div> : <div className="description col-8">{row.description}</div>)}
                                                {!isMobile ? <div className="credits-value col-1">{row.credits_value}</div> : <div className="credits-value col-0">{row.credits_value}</div>}
                                            </div>
                                            {row.link && <a className="name row" href={row.link}>{row.name ? row.name : 'LINK'}</a>}
                                            <hr />
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </AccordionDetails>
                </Accordion>
            ))}
        </div>
    </div>;
};

class c86AccordionsWithTables extends TemplateComponent {
    componentRender(data) {
        return (
            <AccordionsWithTables data={data} lang={this.props.language} />
        )
    }
}

export default c86AccordionsWithTables;
